// ======================================================================
// File Name       : ReservedEmailConfirmDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, isInvalid } from 'redux-form';
import * as emailActions from '../../actions/EmailAction';
import { DEFAULT_DATE_FORMAT_SERVER_NO_MINUTE, MODE, RETURN_MAX_NUM_1000 } from '../../constants';
import { EMAIL_TYPE, RESERVED_FLAG } from '../../constants/EmailConstants';
import { EMAIL_LIST, RESERVED_EMAIL_LIST } from '../../constants/PathConstants';
import ModalWrapper from '../modal/ModalWrapper';
import ReservedEmailInfo from './ReservedEmailInfo';
import { hideLoading, showLoading } from '../../utils/PageUtils';

class ReservedEmailConfirmDialog extends React.Component {
  constructor() {
    super();
    this.onOK = this.onOK.bind(this);
    this.getModalOptions = this.getModalOptions.bind(this);
  }

  /**
   * Click OK on confirm dialog
   */
  onOK() {
    const { formValues, dispatch, invalid, history } = this.props;
    if (invalid) {
      return;
    }
    dispatch(showLoading());
    this.props.hideModal();
    let params = {};
    const editType = this.props.isEdit ? MODE.EDIT_MODE : MODE.NEW_MODE;
    if (formValues.emailReceiverList && Object.keys(formValues.emailReceiverList).length > RETURN_MAX_NUM_1000) {
      const param = {
        emailReceiverList: Object.keys(formValues.emailReceiverList),
      };
      dispatch(emailActions.saveReceiver(param)).then((receiverSaveKey) => {
        params = this.createParams(editType, formValues);
        params.emailReceiverSaveKey = receiverSaveKey;
        dispatch(emailActions.registerEditMail(editType, params)).then((error) => {
          let returnPage = EMAIL_LIST;
          if (formValues.reservedFlag) {
            returnPage = RESERVED_EMAIL_LIST;
          }
          dispatch(hideLoading());
          !error && history.push(returnPage);
        });
      });
    } else {
      params = this.createParams(editType, formValues);
      formValues.emailReceiverList && (params.emailReceiverList = Object.keys(formValues.emailReceiverList));
      dispatch(emailActions.registerEditMail(editType, params)).then((error) => {
        let returnPage = EMAIL_LIST;
        if (formValues.reservedFlag) {
          returnPage = RESERVED_EMAIL_LIST;
        }

        dispatch(hideLoading());
        !error && history.push(returnPage);
      });
    }
  }

  createParams(editType, formValues) {
    const param = {};
    if (formValues.reservedFlag) {
      param.reservedEmailTitle = formValues.emailTitle;
      param.reservedEmailContents = formValues.emailContents;
      param.reservedEmailReplyTo = formValues.emailReplyTo;
      param.reservedDate = moment(formValues.reservedDate).format(DEFAULT_DATE_FORMAT_SERVER_NO_MINUTE);
      param.emailType =
        formValues.isUsedTemplate === 1
          ? EMAIL_TYPE.RESERVETION_COURSE_INCOMPLE_NOTIFICATION
          : EMAIL_TYPE.RESERVATION;
      param.reservedFlag = RESERVED_FLAG.RESERVATION;
    } else {
      param.emailTitle = formValues.emailTitle;
      param.emailContents = formValues.emailContents;
      param.emailReplyTo = formValues.emailReplyTo;
      param.emailType =
        formValues.isUsedTemplate === 1
          ? EMAIL_TYPE.IMMEDIATE_COURSE_INCOMPLETE_NOTIFICATION
          : EMAIL_TYPE.IMMEDIATE;
      param.reservedFlag = RESERVED_FLAG.IMMEDIATE;
    }

    if (editType === MODE.EDIT_MODE) {
      param.emailSenderIdAuto = formValues.emailSenderIdAuto;
    }

    return param;
  }

  getModalOptions() {
    const { formValues } = this.props;
    return {
      title: formValues && formValues.reservedFlag ? '以下の内容で送信予約します' : '以下の内容で送信します',
      footerBtns: [
        { name: 'キャンセル', onClick: this.props.onCancel, variant: 'default' },
        { name: 'OK', onClick: this.onOK, variant: 'primary' },
      ],
    };
  }

  render() {
    return (
      <ModalWrapper
        {...this.getModalOptions()}
        hideModal={this.props.hideModal}
      >
        <ReservedEmailInfo />
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { emailInfo, emailReceiverSaveKey } = state.email;
  const formValues = getFormValues('emailRegisterEditForm')(state);

  return {
    ...{ emailInfo },
    formValues,
    invalid: isInvalid('emailRegisterEditForm')(state),
    emailReceiverSaveKey,
  };
};

export default connect(mapStateToProps)(ReservedEmailConfirmDialog);
